import __request__ from "routing/request";
export function listPredefined(entity_list_id, JSONbody, requestOptions) {
  return __request__("POST", `/entitylists/preferences/list_predefined/${entity_list_id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(entity_list_id, layout_variant, requestOptions) {
  return __request__("GET", `/entitylists/preferences/${entity_list_id}`, null, { "layout_variant": layout_variant }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(entity_list_id, layout_variant, requestOptions) {
  return __request__("DELETE", `/entitylists/preferences/${entity_list_id}`, null, { "layout_variant": layout_variant }, {
    "Accept": []
  }, requestOptions);
}
export function create(JSONbody, entity_list_id, layout_variant, requestOptions) {
  return __request__("POST", `/entitylists/preferences/${entity_list_id}`, JSONbody, { "layout_variant": layout_variant }, {
    "Accept": []
  }, requestOptions);
}
